import { ExclamationCircleFilled } from '@ant-design/icons'
// import CardAddApi from '@api/kong_kong/CardAddApi'
import bi_nuo_api from '@api/bi_nuo'
import Api from '@api/shou_xie/setMeal'
import {
  EDIT_CASE_PATH_A,
  PUBLISH_CASE_PATH_A,
  PUBLISH_EXAMPLE_INNER
} from '@constant'
import BaseStore from '@store/table'
import {
  getMerchantInfo,
  isStoreAccount,
  isStoreHidden,
  isTeam,
  statistic,
  isSiYiTeam
} from '@util'
import { message, Modal } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import { action, observable } from 'mobx'
import React from 'react'
import { MENU_ALL, MENU_NOT_CLASSIFY } from './constant'

class Store extends BaseStore {
  $beforeGet = async () => {
    await this.getMenuList()
    return (this.$beforeGet = null)
  }
  $listApi = Api.listApi
  $loadMore = false
  searchBar = null

  @observable sub_merchant_id = '' // 司仪团队成员使用
  @observable isSort = false
  @observable merchant_category_id = ''
  @observable merchantInfo = {}
  @observable is_cover_img = undefined
  @action
  updateMerchantInfo = data => {
    this.merchantInfo = data || {}
  }

  @observable grayTestFlag = false
  @action
  getGrayCity() {
    const merchantId = getMerchantInfo().id
    Api.getGrayCity({
      merchantId
    }).then(({ data: { weddingPlan } }) => {
      this.grayTestFlag = weddingPlan?.testCity == 1
      // console.log(this.grayTestFlag)
    })
  }

  @observable showViolation = false
  @observable violationList = []
  @observable violationTotal = 0
  @observable violationPageSize = 30
  @observable violationPageNum = 1
  @observable violationLoading = false

  @action
  setViolationPageNum(num) {
    this.violationPageNum = num
    this.getVioloationList()
  }

  @action
  setViolationPageSize(num) {
    this.violationPageSize = num
    this.getVioloationList()
  }

  /**
   *
   * @param {string} type 需要修改的observable
   * @param {any} value 修改的值
   * @param {boolean} ajax 是否进行请求
   * @param {function} fn 执行传入的方法
   */
  @action
  setStoreData = (type, value, ajax = false) => {
    this[type] = value
    if (ajax) {
      this.$getList(1)
    }
  }

  $getParams = () => {
    let { key, merchant_category_id } = this

    if (this.isSort) {
      return {
        with_pending: 1,
        is_one_button: this.oneButton ? 1 : 0,
        is_sort: 1,
        commodity_type: 1,
        merchant_category_id
      }
    }

    const params = {
      commodity_type: 1,
      is_sold_out: key == 4 ? 1 : 0,
      property_id: isStoreAccount() ? this.currentProperty : null,
      sub_merchant_id: !isSiYiTeam() ? this.sub_merchant_id : null,
      emcee_member_id: isSiYiTeam() ? this.sub_merchant_id : null,
      merchant_category_id,
      title_search: this.title_search || '',
      status: 1,
      cover: this.is_cover_img || '',
      no_set_area: this.is_cover_img === '4' ? 1 : undefined,
      set_meal_sort: this.$sorter.order
        ? this.$sorter.order === 'ascend'
          ? 'sort_uv_asc'
          : 'sort_uv_desc'
        : ''
    }

    return {
      with_pending: 1,
      ...this.$params,
      ...params
    }
  }

  $extraOp = data => {
    this.searchNum = data.total_count
  }

  @action
  getVioloationList() {
    this.violationLoading = true
    Api.getVioloationList({
      pageSize: this.violationPageSize,
      pageNum: this.violationPageNum
    }).then(({ success, data }) => {
      this.violationLoading = false
      if (success) {
        this.violationTotal = data.totalCount
        const newData = data.list.map(e => ({
          ...e,
          key: e.id,
          type: e.name,
          caseName: e?.caseData?.title,
          id: e?.caseData?.id,
          property_id: e?.caseData?.propertyId,
          noticeTime: e.notifyAt,
          punishTime: e.beginAt || '-',
          punishResult: e.items || '-',
          punishState:
            e.status == 1
              ? '处罚中'
              : e.status == 2
                ? '处罚结束'
                : e.status == 0
                  ? '待处罚'
                  : '-'
        }))
        this.violationList = newData
        // console.log(newData)
      }
    })
  }

  changeTabCb = async key => {
    this.key = key
    if (key === '5') {
      // 违规tab
      this.showViolation = true
      // 获取违规列表数据
      this.getVioloationList()
    } else {
      this.showViolation = false
      await this.getMenuList()
      this.merchant_category_id = isEmpty(this.menuList)
        ? ''
        : this.menuList[0].id
      this.$getList(1)
    }
  }

  @observable key = '1'
  changeTab = async key => {
    if (this.isSort) {
      if (!this.orderIsChanged) {
        // this.changeTabCb(key)
        this.key = key
        await this.getMenuList()
        this.merchant_category_id = isEmpty(this.menuList)
          ? ''
          : this.menuList[0].id
        this.sortCancle()
        return
      }
      Modal.confirm({
        title: '是否保存此次案例排序？',
        onOk: async () => {
          await this.saveCaseSort()
          this.changeTabCb()
        }
      })
      return
    }
    this.$sorter = {}
    this.changeTabCb(key)
  }

  @observable currentProperty = '1'

  @observable propertyList = []
  getPropertyList = async () => {
    const {
      data: { list }
    } = await Api.mealProperties({ commodity_type: 1 })
    this.propertyList = list || []
  }

  changeProperty = id => {
    this.currentProperty = id
    this.$sorter = {}
    this.$getList(1)
  }

  @observable categoryList = []
  @action
  merchantCategory = async () => {
    const { data } = await Api.merchantCategory()
    this.categoryList = isEmpty(data) ? [] : data
  }
  @action
  selectChange = async (id, meal_type, value) => {
    let { success } = await Api.extendsEdit({
      id,
      merchant_category_id: value,
      meal_type
    })
    if (success) {
      this.$getList()
      this.getMenuList(false)
      this.merchantCategory()
    }
  }

  @observable ratingTotal = 0
  @action
  getRatingList = async () => {
    //需要优化的数量
    let params = {
      page: 1,
      per_page: 1,
      commodity_type: 1,
      rating: 1
    }
    let {
      data: { total_count },
      success
    } = await Api.listApi(params)
    if (success) {
      this.ratingTotal = total_count
    }
  }
  showModalFn = (id, sold, flag, is_in_brand, record) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    let msg = isStoreHidden()
    if (sold !== 'del' && msg != 'success') {
      message.error(msg)
      return false
    }
    const that = this
    if (sold == 'del' || sold == false) {
      Modal.confirm({
        icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
        title: sold == 'del' ? '确认要删除该案例吗' : '确认要下架吗',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          if (sold == 'del') {
            that.deleteSetMealFn(id, flag)
          } else {
            that.soldOutFn(id, sold, flag)
          }
        }
      })
    } else {
      let content = {
        title: '确认要上架吗',
        okText: '确定',
        cancelText: '取消',
        onOk: () => that.soldOutFn(id, sold, flag)
      }
      if (record.normative != 1 || record.is_set_area == 0) {
        content = {
          title:
            record.normative != 1
              ? '由于案例运营规则的调整，该案例信息缺失，请修改后发布案例，审核通过后即可上架。'
              : '该案例图片未设置区域，请修改后发布案例，审核通过后即可上架',

          okText: '编辑',
          cancelText: '取消',
          onOk: () => that.toEdit(record)()
        }
      }

      Modal.confirm({
        icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
        title: content.title,
        okText: content.okText,
        cancelText: content.cancelText,
        onOk: content.onOk
      })
    }
  }

  showModalMove = (id, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可移除'
      })
    }
    Modal.confirm({
      content: '你是否确认移除该案例，该操作不可恢复',
      onOk: () => {
        this.deleteSetMealFn(id, flag)
      }
    })
  }

  @action
  showModalMoveCase = id => () => {
    Modal.confirm({
      content: '确认移除后此案例将不在婚礼纪APP中展示',
      onOk: async () => {
        let params = { id, platform: 2 }
        let { success } = await Api.move(params)
        if (success) {
          message.success('操作成功！')
          this.$getList()
        }
      }
    })
  }

  //删除普通套餐
  async deleteSetMealFn(id, flag) {
    const { success } = await Api.deleteSetMeal({ id })
    if (success) {
      if (flag == 1) {
        this.$getList(1)
      } else {
        window.location.reload()
      }
    }
  }
  //普通套餐上下架
  async soldOutFn(id, sold, flag) {
    let params = {
      id: id,
      sold_out: sold == true ? 0 : 1,
      type: 'example',
      status: 1
    }
    const { success } = await Api.SoldOut(params)
    if (success) {
      if (flag == 1) {
        const queryList = () => {
          // 处理页数
          const { current, pageSize } = this.$pagination
          let page = current
          if (page > 1 && this.$list.length % pageSize === 1) {
            page = current - 1
          }
          this.$getList(page)
        }
        queryList()
      } else {
        window.location.reload()
      }
    }
  }

  @observable
  modalIf = {
    type: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }
  @action
  publishFn = () => {
    statistic(PUBLISH_EXAMPLE_INNER)
    let msg = isStoreHidden()
    if (msg != 'success') {
      message.error(msg)
      return false
    }
    if (isStoreAccount()) {
      // window.open('#/localMerchant/case/publish/chooseProperty')
      window.location.href = '#/localMerchant/case/publish/chooseProperty'
    } else {
      // window.open(PUBLISH_CASE_PATH + '?from=case')
      // window.open('#/localMerchant/case/add')
      window.location.href = `${PUBLISH_CASE_PATH_A}?propertyId=${
        this.merchantInfo.property_id
      }`
    }
  }

  @action
  onCancel = () => {
    if (this.modalIf.btn1 == '继续发布') {
      window.location.href = '#/localMerchant/case/add'
    } else {
    }
    this.modalIf.isShow = false
  }

  @action
  toEdit = record => () => {
    let msg = isStoreHidden()
    if (record.is_in_brand) {
      return Modal.info({
        title: '案例在品牌页中不可编辑'
      })
    }
    if (msg == 'success') {
      window.open(
        `${EDIT_CASE_PATH_A}/${record.id}?propertyId=${record.property_id}`
      )
    } else {
      return message.error(msg)
    }
  }

  @action
  changeShopShow = (is_show, id) => async () => {
    let params = {
      id,
      is_show: is_show == 1 ? 0 : 1 || 1
    }
    let { success } = await Api.move(params)
    if (success) {
      message.success('操作成功！')
      this.$getList()
    }
  }

  // 是否设置了套餐竖图
  @observable reviewText = ''
  @observable coverPathText = ''
  @observable noSetAreaText = '' // 未设置分区提示
  @observable isSetArea // 是否为图片未设置分区提示 0 代表存在未设置分区的
  @action
  getMealVerticalImg = async () => {
    const { success, data = {} } = await bi_nuo_api.isEditVerticalImage({
      type: 2
    })
    if (success) {
      // 检测是否需要竖图弹窗接口，需要取返
      this.reviewText = data.reviewText || ''
      this.coverPathText = data.coverPathText || ''
      this.isSetArea = data.isSetArea
      this.noSetAreaText = data.noSetAreaText
    }
  }

  /* ————————————————list-设置竖图————————————————*/
  @observable verticalImgVisible = false
  @observable vertical_image = ''

  // 弹窗-打开
  @action
  showVerticalImgModal = ({ id, cover_path }) => {
    this.vertical_image = cover_path
    this.current_id = id
    this.verticalImgVisible = true
  }

  // 弹窗-取消
  @action
  closeVerticalImgModal = () => {
    this.vertical_image = ''
    this.verticalImgVisible = false
    this.current_id = ''
  }

  // 弹窗-保存
  @action
  saveVerticalImgModal = () => {
    // 清空链接，关闭弹窗
    this.closeVerticalImgModal()
  }

  // 图片裁剪
  @action
  verticalImgModalonCliped = url => {
    this.vertical_image = url
    this.sendVerticalImg(url)
    this.closeVerticalImgModal()
  }

  // 图片删除
  @action
  verticalImgModalonDelete = () => {
    this.vertical_image = ''
  }

  @action
  sendVerticalImg = async vertical_image => {
    const { success } = await bi_nuo_api.editVerticalImage({
      id: this.current_id,
      vertical_image
    })
    if (success) {
      this.$getList()
    }
  }

  orderIsChanged = false //是否排序过
  @action
  moveRow = (dragIndex, hoverIndex) => {
    this.orderIsChanged = true
    const temp = this.$list[dragIndex]
    this.$list[dragIndex] = this.$list[hoverIndex]
    this.$list[hoverIndex] = temp
  }

  @action
  toTop = index => {
    const temp = this.$list.splice(index, 1)
    this.$list.unshift(temp[0])
  }

  @action
  moveMenu = (dragIndex, hoverIndex) => {
    const temp = this.menuList[dragIndex]
    this.menuList[dragIndex] = this.menuList[hoverIndex]
    this.menuList[hoverIndex] = temp
  }

  timer = null
  @action
  loadMore = e => {
    clearTimeout(this.timer)
    if (
      e.target.clientHeight + e.target.scrollTop + 100 >=
        e.target.scrollHeight &&
      this.isSort
    ) {
      if (this.$pagination.total > this.$list.length) {
        this.timer = setTimeout(() => {
          this.$getList(this.$pagination.current + 1)
        }, 400)
      }
    }
  }

  @action
  sortCancle = () => {
    this.isSort = false
    this.oneButton = false
    // await this.getMenuList()
    this.$loadMore = false
    this.orderIsChanged = false
    this.$getList(1)
  }

  @action
  saveCaseSort = async () => {
    this.$loadMore = false
    const ids = this.$list.map(item => item.id)
    const params = {
      is_one_button: this.oneButton ? 1 : 0,
      order_ids: ids.join(','),
      merchant_category_id: this.merchant_category_id
    }
    isTeam()
      ? await Api.saveMainCaseSort(params)
      : await Api.saveCaseSort(params)
    this.sortCancle()
  }

  @observable searchNum = 0
  @observable menuList = []
  @action
  getMenuList = async (shouldUpdateMenu = true) => {
    const { data } = await Api.getMenuList({
      isDraft: 0,
      isFilterItem: 1,
      isSortPage: this.isSort ? 1 : 0,
      page: 1,
      perPage: 99,
      isSoldOut: this.key == 4 ? 1 : 0,
      sub_merchant_id: this.sub_merchant_id,
      title_search: this.title_search
    })
    if (this.title_search) {
      this.menuList = data.list.filter(
        item =>
          item.itemCount || item.id == MENU_ALL || item.id == MENU_NOT_CLASSIFY
      )
    } else {
      this.menuList = data.list || []
    }
    if (shouldUpdateMenu) {
      this.merchant_category_id = this.menuList[0].id
    }
  }
  // 添加案例分类
  @action
  submitCasseCate = async value => {
    let { success } = value.id
      ? await Api.editCase(value)
      : await Api.categoryAdd(value)
    if (success) {
      await this.getMenuList()
      this.merchantCategory()
      this.$getList(1)
    }
  }

  @action
  menuListSort = () => {
    // 去掉全部和未分类
    let ids = this.menuList
      .map(item => item.id)
      .filter(id => id != MENU_ALL && id != MENU_NOT_CLASSIFY)

    Api.menuListSort({
      ids: ids.join(',')
    })
  }

  @action
  sortManage = async () => {
    this.isSort = true
    this.title_search = ''
    this.is_cover_img = ''
    this.$loadMore = true
    this.$sorter = {}
    this.$resetParams()
    // await this.getMenuList()
    this.$getList(1)
  }

  oneButton = false
  @action
  oneButtonSort = () => {
    this.oneButton = true
    this.sortManage()
  }

  @observable draftCount = 0
  @action
  getDraftCount = async () => {
    const { data = 0, success } = await Api.getDraftCount()
    if (success) {
      this.draftCount = data
    }
  }

  // 案例名输入框内容
  @observable title_search = ''
  @action
  onTitleSearch = async value => {
    this.title_search = value
    value = value.trim()
    // if (value == '') {
    //   return
    // }
    await this.getMenuList()
    this.$getList(1)
  }

  titleTimer = null
  @action
  onTitleChange = async value => {
    if (this.titleTimer) {
      clearTimeout(this.titleTimer)
    }
    this.title_search = value

    this.titleTimer = setTimeout(() => {
      this.onTitleSearch(value)
    }, 300)
  }

  @action
  beforeOnChange = (type, value, ajax) => {
    this.$sorter = {}
    if (!this.orderIsChanged) {
      this[type] = value
      if (ajax) {
        this.$getList(1)
      }
      return
    }
    Modal.confirm({
      title: '是否保存此次案例排序？',
      onOk: async () => {
        await this.saveCaseSort()
        this[type] = value
        if (ajax) {
          this.$getList(1)
        }
      },
      onCancel: () => {
        this[type] = value
        this.$getList(1)
        this.orderIsChanged = false
      }
    })
  }

  @action
  selectGroupMember = async value => {
    this.sub_merchant_id = value
    this.key = '1'
    this.$resetParams()
    await this.getMenuList()
    this.$getList(1)
  }

  @action
  seeNoSettingImage = () => {
    // 若是图片分区未设置的提示
    this.is_cover_img = '4'
    this.changeTab('1')
  }

  @action
  seeUnUploadCover = () => {
    if (this.isSetArea === 0) {
      this.seeNoSettingImage()
      return
    }
    this.is_cover_img = '2'
    this.merchant_category_id = '0'
    this.$getList(1)
  }

  @action
  reset = () => {
    this.sub_merchant_id = ''
    this.onTitleSearch('')
  }
}
export default new Store()
